<template>
<div class="main">
	<Steps :index="1" :product-name="info.productName||''" />
	<slot :info="info" name="recognizeInfo"></slot>
	<ApplicantInfo :info="info.applicantInfo" :upload-file-list="applicantUploadFileList" class="mt20"/>
	<InvoiceInfo :info="info.invoiceInfo" :type="info.applicantInfo.identityType"/>
	<slot :info="info" name="insuranceSlip" ></slot>
	<!-- 核保中 -->
	<div v-if="applicationStatus=='REVIEWING'">
		<div class="mt20 center">
			<p>
				<Button type="primary" disabled>核保中</Button>
			</p>
			<div class="mt20">
				<p class="red">正在核保中，请耐心等待</p>
			</div>
		</div>
	</div>
	<!-- 核保失败 -->
	<div v-if="applicationStatus=='REVIEWED_REJECTED'">
		<div class="mt20 center">
			<p class="mt10">实际支付：<span class="price">{{info.premium}}元</span></p>
			<p class="mt10 center red font14">
				失败原因：{{ info.remark }}
			</p>
		</div>
	</div>
	<!-- 待确认 -->
	<div v-if="info.productCode&&info.productCode=='TRUCK_EMPLOYERS_LIABILITY_INSURANCE_WITH_PEOPLE'&& applicationStatus=='UNCONFIRMED'">
		<div class="mt15 agree">
			<Checkbox v-model="agree">我已经阅读并同意</Checkbox>
			<slot name="agree"></slot>
		</div>
		<div class="mt20 center">
			<p>实际支付：<span class="price">{{info.premium||''}}元</span></p>
			<p class="mt10">
				<Button type="primary" @click="toPay" :disabled="!agree" :loading="loading">立即支付</Button>
			</p>
		</div>
	</div>
	<div v-if="info.productCode&&info.productCode!='TRUCK_EMPLOYERS_LIABILITY_INSURANCE_WITH_PEOPLE'">
		<div class="mt15 agree">
			<Checkbox v-model="agree">我已经阅读并同意</Checkbox>
			<slot name="agree"></slot>
		</div>
		<div class="mt20 center">
			<p>实际支付：<span class="price">{{info.premium||''}}元</span></p>
			<p class="mt10">
				<Button type="primary" @click="toPay" :disabled="!agree" :loading="loading">立即支付</Button>
			</p>
		</div>
	</div>
</div>
</template>
<script>
import ApplicantInfo from './ApplicantInfo'
import InvoiceInfo from './InvoiceInfo'
import Steps from './Steps'
import {applicantUploadFileMap} from '@/pages/haierProduct/common/dictionary'
import track from "@/mixin/track";
export default {
	mixins:[track],
	components:{ 
		ApplicantInfo,
		InvoiceInfo,
		Steps },
	props:{
		validateInsuranceSlip:{ 
			type:Function,
			default:async function(){
				return { fileList: [] };
			}
		},
		type:{
			type:String,
			default:''
		}
	},
data () {
		return {
			info:{
				applicantInfo:{},
				subjectMatter:[],
				subjectMatterUrls:'',
				invoiceInfo:{
					invoiceType:'NOT'
				}
			},
			applicationStatus:'',
			loading:false,
			agree:false,
			id:this.$route.params.id
		}
	},
	computed: {
		applicantUploadFileList(){
			let list=applicantUploadFileMap[this.info.productCode]
			if(list){
				return list.filter(item=>{
					return item.identityType==this.info.applicantInfo.identityType
				})
			}
			return []
		},
	},
	created(){
		if(this.id){
			this.getInfo()
		}
	},
	mounted () {
		// 回溯 开始录制
		this.$nextTick(this.startRecord);
	},
	methods:{
		// 根据id获取信息
		getInfo(){
			let url = this.$route.params.type=='person'?'/broker/insurance/application/detail.dst':'/broker/insurance/application/detail'
			this.$axios.post(url,{
				applicationId:this.id
			}).then(res=>{
				this.info=res;
				this.info.applicantInfo=res.applicantList&&res.applicantList.length>0?res.applicantList[0]:{};
				this.applicationStatus = res.applicationStatus;
			});
		},
		getSatus(){
			setTimeout(()=>{
				this.$axios.post('/broker/insurance/application/detail.dst',{
					applicationId: this.id
				}).then(res=>{
					this.applicationStatus = res.applicationStatus;
					this.info.premium = res.premium;
					this.info.remark = res.remark;
					if((res.applicationStatus =='UNCONFIRMED'||res.applicationStatus =='QUOTE_REJECTED'||res.applicationStatus =='REVIEWED_REJECTED'||res.applicationStatus =='REJECTED')||res.applicationStatus =='REVIEWED_REJECTED'){
						clearInterval(this.timer);
					}
					if(res.applicationStatus=='CONFIRMED'){
						// 调获取订单号接口
						this.$axios.post('/broker/order/list.json',{
							bizId:'TRUCK_EMPLOYERS_LIABILITY_INSURANCE',
							applicationNo: this.info.applicationNo,
							count:10,
							page:1
						}).then(async res=>{
							// 回溯 停止录制
							await this.stopRecord({
								session_key:sessionStorage.track_session_key,
								policy_id:this.info.applicationNo
							});
							clearInterval(this.timer)
							window.location.href=`/common.html#/common-pay/${res.data}`
						})
					}
				});
          	}, 0)
		},
		async toPay () {
			if(this.type=='person'){
				// 校验投保单
				const insuranceForm = await this.validateInsuranceSlip();
				if(!insuranceForm){
					return;
				}
				this.loading=true;
				this.$axios.post('/broker/attachment/uploadAttachmentFile.json.all',{
				bizId: this.info.bizId,
					productCode: this.info.productCode,
					applicationId: this.id,
					fileList: insuranceForm.fileList
				}).then(res=>{
					console.log(res,'person类型')
					this.confirm()
				})
			} else{
				console.log('其它类型类型')
				this.loading=true;
				this.confirm()
			}
		},
		confirm(){
			this.$axios.post('/broker/insurance/application/confirm.all',{
				applicationId:this.id,
			}).then(async res=>{
				if(res.code==10000000){
					if(!res.data){
						setTimeout(()=>{
							this.loading = false
						},5000)
						this.timer = setInterval(() => {
							this.getSatus()
						}, 5000)
					} else {
						// 回溯 停止录制
						await this.stopRecord({
							session_key:sessionStorage.track_session_key,
							policy_id:this.info.applicationNo
						});
						window.location.href=`/common.html#/common-pay/${res.data}`
					}
				}else{
					this.loading = false;
					this.alert(res.msg);
				}
			}).catch(res=>{
				this.loading = false;
			});
		}
	}
}
</script>
<style scoped lang="less">
	.main{
		background: #fff;
		margin-top: 15px;
		padding :30px 40px;
	}
	.mt20{
		font-size: 25px;
		line-height: 1.8;
	}
	span.price{
		color:#FF0000;
		font-weight: bold;
	}
	.agree{
		display: flex;
	}
</style>



// WEBPACK FOOTER //
// src/pages/haierProduct/components/common/ConfirmContainer.vue